import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import planningImg from "../../assets/images/home/planning.svg";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));

const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        // height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    const { dataEva, colors } = props
    const { t } = useTranslation()
    let row = [];
    let percent = (dataEva) => {
        let sumpercent = 0
        if (dataEva > 0) {
            sumpercent = ((dataEva / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    for (var i = 0; i < dataEva.series.length; i++) {
        row.push(
            <Box key={dataEva.series[i].name} display="flex" alignItems="center" pt={1}>
                <Box sx={{ width: "5%" }}>
                    <div className="bar-legend-square" style={{ backgroundColor: colors[i] }}></div>
                </Box>
                <Box sx={{ width: "80%" }}><Typography variant="label" style={styles.barLegend} fontSize={16} lineHeight="24px" fontWeight={400} sx={{ color: "#A3A3A3 !important" }}>{dataEva.series[i].name === "Goal" ? t('evaluation.goal') : dataEva.series[i].name === "Competency" ? t('evaluation.competency') : dataEva.series[i].name}</Typography></Box>
                <Box sx={{ width: "15%", textAlign: "right" }}><Typography fontSize={16} lineHeight="24px" variant="label" style={styles.barLegend} fontWeight={500} color="#939393">{dataEva.series[i].data[0]}%</Typography></Box>
            </Box>
        );
    }
    return (row)
}

export default function EvaluationRatio(props) {
    const { t } = useTranslation();
    const { datas, dataPA, checkAdd, colors, title } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState(["#FA9349", "#74C1ED", "#31B09B", "#4978B9", "#7457A3", "#C36BA5", "#EDB627", "#6CBF6A", "#327134", "#C55F5F"]);
    const [dataBarChart, setDataBarChart] = React.useState([]);
    const [sum, setSum] = React.useState(100)

    useEffect(() => {
        mapping()
    }, [datas]);
    let chartOptions = {
        type: "bar",
        series: typeList,
        options: {
            unit: "คะแนน",
            chart: {
                type: "bar",
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
                offsetX: 0,
                offsetY: 0
            },
            colors: [],
            states: {
                hover: {
                    filter: {
                        type: 'darken',
                        value: 0.9,
                    }
                },
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    // borderRadius: 5,
                    barHeight: "100%",
                    colors: {
                        ranges: [{
                            from: 0,
                            to: 0,
                            color: '#F0F0F0'
                        }],
                        backgroundBarColors: ['#F0F0F0'],
                        backgroundBarOpacity: 1,
                        backgroundBarRadius: 5,
                    },
                },
            },
            grid: {
                show: false,
                padding: {
                    top: -50,
                    right: 0,
                    bottom: -10,
                    left: -20
                },
            },
            stroke: {
                width: 0,
                colors: ["#fff"],
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                // enabled: true,
                // enabledOnSeries: undefined,
                // shared: true,
                // followCursor: false,
                // intersect: false,
                // inverseOrder: false,
                // custom: undefined,
                // fillSeriesColor: false,
                // theme: false,
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                style: {
                    fontSize: '14px',
                    fontFamily: "Kanit",
                    fontWeight: 300,
                },
                x: {
                    show: false,
                },
                y: {
                    style: {
                        fontSize: '14px',
                        fontFamily: "Kanit",
                        fontWeight: 300,
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
            },
            fill: {
                opacity: 1,
                // type: ['solid', 'gradient'],
                // colors: ["#FA9349","#74C1ED"]
            },
            legend: {
                show: false,
                position: "bottom",
                horizontalAlign: "left",
                offsetX: -33,
                offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                        " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
                        "</span>"
                    );
                    // return (
                    //   "<span class='fs-12px ml-2'>" +
                    //   val +
                    //   "</span><span class='fs-12px fw-600 float-right'>" +
                    //   (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0 )+
                    // "% (" +
                    // (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                    // ")</span>"
                    // );
                },
            },
        },
    };
    // let totalScore = () => {
    //     let totals = 0
    //     if (typeList.length > 0) {
    //         typeList.map((data) => { totals = totals + Number(data?.data[0]) })
    //     }
    //     return totals.toFixed(2)
    // }
    // let calculateScore = (data) => {
    //     let sum = eval(data.calculate_score)
    //     let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
    //     return scores
    // }
    // let sumScoreAccumulateUse = (data) => {
    //     let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
    //     for (let index = 0; index <= data.rb_condition.length - 1; index++) {
    //         totals = totals + Number(calculateScore(data.rb_condition[index]))
    //     }
    //     return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    // }
    const mapping = () => {
        if (datas !== undefined && datas !== null && datas !== "null") {
            var typeData = []
            var score = 0
            let sumData = []
            for (let index = 0; index <= datas.length - 1; index++) {
                typeData.push({ name: datas[index]?.name, data: [datas[index]?.value] })
                score += parseFloat(datas[index]?.value)
            }
            setTypeList(typeData)
            setSum(score)
        }
    }

    return (
        <Box px={2} pt={2} pb={3} sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
            {/*<CardContent>*/}
            {/*    <Grid container spacing={0}>*/}
            {/*        <Grid item>*/}
            {/*            <div*/}
            {/*                className={`${classes.iconContainer} ${classes.blueBg}`}*/}
            {/*            >*/}
            {/*                <img src={planningImg} alt="bannerImage"/>*/}
            {/*            </div>*/}
            {/*        </Grid>*/}
            {/*        <Grid item ml={1}>*/}
            {/*            <Grid container spacing={0}>*/}
            {/*                <Grid item>*/}
            {/*                    <Typography fontSize={24} lineHeight={1}>*/}
            {/*                        {t("home.label.paPlanning")}*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*            <Grid container spacing={0}>*/}
            {/*                <Grid item p={0}>*/}
            {/*                    <Typography fontSize={14} lineHeight={1}>*/}
            {/*                        แผนการประเมินรอบที่ 1 (เวอร์ชัน1.0)*/}
            {/*                        /!*{t("home.label.title")}*!/*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Grid>*/}
            {/*</CardContent>*/}
            {/*<Divider/>*/}
            <Box className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", pb: "10px" }}>
                <Grid container pb={2}>
                    <Grid item lg={6} xs={10}>
                        <Typography fontSize={20} lineHeight="22px" fontWeight={600} color="#404349">
                            {title || t('evaluation.evaluationRatio')}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={12} md={12} xs={12} sx={{ ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }}>
                        <ApexCharts
                            options={{ ...chartOptions.options, colors: colorBar }}
                            series={chartOptions.series}
                            type={chartOptions.type}
                            height="40px"
                        ></ApexCharts>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={12} md={12} xs={12}>
                        <Grid container>
                            <Grid item lg={12} md={12} xs={12}>
                                <BarLegend dataEva={chartOptions} colors={colorBar}></BarLegend>
                                {/* { BarLegend(chartOptions) } */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                <Divider />
                <CardActions sx={{ paddingRight: "0px", paddingTop: "8px", pb: "3px" }}>
                    <Grid container mt={0}>
                        <Grid item display="flex" justifyContent="flex-end" sx={{ flexFlow: "column", marginLeft: "auto" }}>
                            <Typography fontSize={16} lineHeight="24px" fontWeight={600} color="#404349" textAlign="right" variant="label" >
                                {/* {t("home.label.title")} */}
                                {t('label.total')}
                                <Typography pl={2} fontSize={16} lineHeight="24px" fontWeight={400} textAlign="right" color="#404349" variant="label">{sum + "%"}</Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                </CardActions>
            </Box>
        </Box>
    )
}

